import React from 'react'
import {
  columnCover,
  columnName,
  columnInfo,
  columnExtTags,
  columnExtSku,
  columnDraftState,
} from 'components/template-data-table-column'
import { DataTableRowActions } from './data-table-row-action'
export const columns = [
  {
    header: '#',
    cell: ({ row }) => row.index + 1,
  },
  columnCover,
  columnName,
  columnInfo,
  columnDraftState,
  columnExtTags,
  columnExtSku,
  {
    header: 'Actions',
    cell: ({ row }) => (
      <>
        <DataTableRowActions row={row} />
      </>
    ),
  },
]
